import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-links-container">
        <div className="navbar-links desktop-links footer-links">
          <Link to="/about-us">About Us</Link>
          <Link to="/connect-with-us">Contact Us</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
        </div>
      </div>
      <p>&copy; {new Date().getFullYear()} Ziyarat Guide. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
